var mock_data = {
	senderId: '47615309344527',
	senderDeviceId: null,
	senderSource: 2,
	toId: '66100684310799',
	toDeviceId: null,
	toSource: 2,
	msgType: 2,
	showType: 'wuba_card',
  content:  {
  	xml_data: "<msg n='张先生'>" +
	"<font n='宋体' s='12' b='0' i='0' ul='0' c='#000000'/>" +
		"<text c='五八测试十九向您发出职位邀请！职位：招聘建筑，薪资：面议，工作地点：清徐东于，电话：。立即联系，应聘成功率翻倍！'/>" +
		"<extend id='40532646292106'/>" +
		"<zhaopin type='1' source='0101'>" +
			"<content" +
				" cardname='职位邀请'" +
				" t='五八测试十九向您发出职位邀请！'" +
				" id='40532646292106'" +
				" c='招聘建筑'" +
				" x='面议'" +
				" dis='清徐东于'" +
				" fl='五险一金 包住 包吃 年底双薪 周末双休 交通补助 加班补助 饭补 话补 房补'" +
				" p=''" +
				" l='http://ty.58.com/zpfangchanjianzhu/40532646292106x.shtml?from=gongzuolaizhaowopc'" +
				" m='http://i.m.58.com/ty/zpfangchanjianzhu/40532646292106x.shtml?from=gongzuolaizhaowom'" +
				" xq='岗位职责：1、负责公司所有施工工程质量和'" +
				" company='五八测试十九'" +
						" catename='建筑'" +
						" phone=''" +
						" reqnum='2'" +
						" reqrecord='中专'" +
						" reqex='不限'" +
						" identification_id='1576749775665'" +
						" st='1'" +
						" longitude='112.556391'" +
						" latitude='37.876989'" +
						" jobtype='1'" +
						" jobclass='1'" +
						" jobstate='1'" +
						" shelvesstate='0'" +
						" joburl='http://zpbb.58.com/zcm/v3/views/position?infoid=40532646292106'" +
			"/>" +
		"</zhaopin>" +
"</msg>",
  	type: 'wuba_card',
  	json_data: {
  		card_sub_type: 'jobinfo',
  		card_content: {
  			jobid: '39921455057569 ',
  			jobname: '销售',
  			jobsalary: '面议',
  			jobwelfare: '五险一金',
  			companyname: '学学家',
  			companyaddress: '阿勒泰哈巴河',
  			jobcontactphone: '',
  			joburl: 'http: //zpbb.58.com/zcm/v3/views/position?infoid=39921455057569',
  		}
  	}
  },
	options: {
		sender_hide: 0,
		sender_iscrypt: 0
	},
	refer: {
		invitation: {
			role: 1,
			cateid: 2626,
			cate_extra: 'wl_tset_cate_extra_001',
			id: 39921455057569,
			title: '销售代表',
			url: 'http://alt.58.com/yewu/',
			rootcateid: 574,
			scene: 'wl_tset_scene_001'
		}
	},
	addition: {
		encrypt: true
	}
};
var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/card-msg-job.html');
var utils = require('../../global/utils');
var _isEmpty = utils.isEmpty;

var CardMsgJob = function (options) {
  (function (self) {
    var defaults = {
      template: template,
			detail_tpl: '<span class="{{style}} job-detail">{{text}}</span>',
			label_tpl: '<span class=job-label>{{text}}</span>'
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;
};
CardMsgJob.prototype = Object.create(BaseMsgItem.prototype);

CardMsgJob.prototype.renderContent = function () {
  var msg = this._data.msg;
  var content = msg.content;
  var element = this._element;
	var json_data = content.json_data;
	var xml_data = content.xml_data;
	var self = this;
	var data_map = {};
	var defHref = 'javascript:void(0)';
	if(!_isEmpty(xml_data)){
		try{
			var parser = new DOMParser();
			var xmlDoc = parser.parseFromString(xml_data,"text/xml");
			var countrys = xmlDoc.getElementsByTagName('content');
			var attributes = !_isEmpty(countrys) && countrys.length ? countrys[0].attributes : [];
			var attributesNames = ['catename', 'fl', 'reqnum', 'c', 'x', 'joburl', 'dis'];
			for(var i=0;i < attributes.length;i++){
				var index = attributesNames.indexOf(attributes[i].name);
				if(index >= 0){
					data_map[attributesNames[index]] = attributes[i].value;
				}
			}
		}catch(e){
			console.log(e);
		}
	}
	if(typeof json_data == 'string'){
		try{
			json_data = JSON.parse(json_data);
		}catch(e){
			json_data = null;
		}
	}
	if(!_isEmpty(json_data) && !_isEmpty(json_data.card_content)){
		var card_content = json_data.card_content;
		if(_isEmpty(data_map['fl'])){
			data_map['fl'] = card_content.jobwelfare || ''
		}
		if(_isEmpty(data_map['catename'])){
			data_map['catename'] = card_content.jobname || ''
		}
		if(_isEmpty(data_map['x'])){
			data_map['x'] = card_content.jobsalary || ''
		}
		if(_isEmpty(data_map['joburl'])){
			data_map['joburl'] = card_content.joburl || ''
		}
		if(_isEmpty(data_map['dis'])){
			data_map['dis'] = card_content.companyaddress || ''
		}
	}

	var card_content = json_data.card_content;
	element.find('.im-job-title').html(data_map.c || '');
	element.find('.im-job-price').html(data_map.x || '');
	var details = [];
	var labels = [];
	var _details = '';
	var _labels = '';
	if(data_map.catename)details.push(data_map.catename);
	if(data_map.dis)details.push(data_map.dis);
	if(data_map.reqnum)details.push('招' + data_map.reqnum + '人');
	if(data_map.fl)labels = data_map.fl.split(' ');
	details.forEach(function(detail, index){
		_details += self._options.detail_tpl.replace('{{style}}', index > 0  ? 'job-border-detail' : '').replace('{{text}}', detail);
	});
	labels.forEach(function(label){
		_labels += self._options.label_tpl.replace('{{text}}', label);
	});
	element.find('.im-job-detail').html(_details);
	element.find('.im-job-label').html(_labels);
	if(data_map.joburl){
		element.find('.im-job-content').attr('href', data_map.joburl || defHref);
	}

	element.find('.im-msg-content').on('click', '[href]', function(e) {
		e.preventDefault();
		var url_jump = $(this).attr('href');
		if (url_jump != defHref) {
		  utils.openPage(url_jump);
		}
	});

};

module.exports = CardMsgJob;
